import { render } from "./HoriontalCard2.vue?vue&type=template&id=11825ee4&ts=true"
import script from "./HoriontalCard2.vue?vue&type=script&lang=ts"
export * from "./HoriontalCard2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__